import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { grantInvestorDataroomAccess } from 'api/dataroom';
import { useInvestorDataroomAccess } from '~/requests/dataroom';

export const useGrantInvestorDataroomAccess = (params = {}) => {
  const dataroomAccess = useInvestorDataroomAccess();
  const dataroom = dataroomAccess?.data?.dataroom;
  
  return useMutation({
    mutationFn: async ({ investorId }: any) => {
      try {
        await grantInvestorDataroomAccess(dataroom?.id, investorId);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    onError() {
      toast.error('Error occurred granting access to the documents. Please try again.');
    },
    onSuccess() {
      toast.success('Successfully granted investor access to the documents.');
    },
    ...params
  });
};